export enum UserCookLeaveLinkDisputeResolutionAbsenceTypeEnum{
    COOK_NOT_AVAILABLE="COOK_NOT_AVAILABLE",
    USER_NOT_AVAILABLE="USER_NOT_AVAILABLE"
}